// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3auI_","info":"Note_info__1YtQz","note":"Note_note__2Nz0h","actions":"Note_actions__2lZdt"};